// extracted by mini-css-extract-plugin
module.exports = {"grid":"OfferFeatureGrid_grid__knu5Y","for-list":"OfferFeatureGrid_for-list__rA2Cr"};